const transformers = [];
const transformerNames = [];

export function evaluate(message, params) {
  const paramsNames = Object.keys(params);
  const paramsValues = Object.values(params);

  // eslint-disable-next-line no-new-func
  return Function(
    ...paramsNames,
    ...transformerNames,
    // eslint-disable-next-line no-template-curly-in-string
    'try { return `' + message + '`; } catch (e) { return `Syntax error`}'
  )(...paramsValues, ...transformers);
}
